export default class extends Controller {
  static targets = ['expandedMenuItem'];

  openMenuItem(event) {
    event.preventDefault();
    this.expandedMenuItemTarget.classList.add('active');
  }

  closeMenuItem(event) {
    event.preventDefault();
    this.expandedMenuItemTarget.classList.remove('active');
  }
};



// WEBPACK FOOTER //
// ./app/components/activity_cards/assets/javascript/activity-cards-menu-item-controller.js